import { Outlet } from "react-router-dom";
export default function FormsLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
